export default __webpack_public_path__ + "static/media/bernygroup3b.d2eb6b29.jpg";